<content-panel class="container">
  <panel-header heading="Facility Energy Credit Eligibility"></panel-header>

  <panel-body>
    <mat-form-field appearance="outline" class="filter-field">
      <mat-label>Filter facilities</mat-label>
      <input
        matInput
        (keyup)="applyFilter($event)"
        placeholder="Name, facility #, or status"
        aria-label="Filter facilities"
      />
    </mat-form-field>

    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
      <!-- Facility Number -->
      <ng-container matColumnDef="facilityNumber">
        <th mat-header-cell *matHeaderCellDef><b>Facility #</b></th>
        <td mat-cell *matCellDef="let facility">{{ facility.KeyChain?.LegacyId }}</td>
      </ng-container>

      <!-- Name -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef><b>Name</b></th>
        <td mat-cell *matCellDef="let facility">{{ facility.Name }}</td>
      </ng-container>

      <!-- Status -->
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef><b>Status</b></th>
        <td mat-cell *matCellDef="let facility">
          @if (facility.IsEnergyCreditsEnabled) {
            <mat-chip class="enabled-chip">Enabled</mat-chip>
          } @else {
            <mat-chip class="disabled-chip">Disabled</mat-chip>
          }
        </td>
      </ng-container>

      <!-- Toggle -->
      <ng-container matColumnDef="toggle">
        <th mat-header-cell *matHeaderCellDef><b>Energy Credits Enabled</b></th>
        <td mat-cell *matCellDef="let facility">
          <mat-slide-toggle
            class="ec-toggle"
            [checked]="facility.IsEnergyCreditsEnabled"
            [disabled]="savingId() === facility.Id"
            (change)="onToggleChange(facility, $event)"
            (click)="$event.stopPropagation()"
            [attr.aria-label]="'Toggle Energy Credits eligibility for ' + facility.Name"
          ></mat-slide-toggle>
        </td>
      </ng-container>

      <tr class="mat-row" *matNoDataRow>
        <td class="empty-table" [attr.colspan]="displayedColumns.length">
          No facilities found.
        </td>
      </tr>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        class="clickable-row"
        (click)="onRowClick(row)"
      ></tr>
    </table>
  </panel-body>
</content-panel>
